import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon } from 'lucide-react';

interface DatePickerProps {
  label: string;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  error?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  placeholderText?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  selected,
  onChange,
  error,
  disabled = false,
  minDate,
  maxDate,
  placeholderText = 'Select date...',
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <ReactDatePicker
          selected={selected}
          onChange={onChange}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholderText}
          dateFormat="yyyy-MM-dd"
          className={`
            block w-full px-4 py-2 text-gray-900 bg-white border rounded-md 
            focus:ring-2 focus:ring-primary focus:border-transparent outline-none
            ${error ? 'border-red-500' : 'border-gray-300'}
            ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
          `}
        />
        <div className="absolute right-3 top-2.5 text-gray-400 pointer-events-none">
          <CalendarIcon size={20} />
        </div>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default DatePicker; 